module.exports = __webpack_public_path__ + "img/slide4.68bd9703.png";